export enum ticketTitles {
    TechnicalIssue = 'Technical Issue',
    HRAdvisory = 'HR Advisory'
}
